import pokemonGoPermissionsPanels from './pokemon-go-permissions';

export { pokemonGoPermissionsPanels }